<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <p
            v-if="!contacts.length"
            class="text-muted mb-0"
        >No contacts found for your company yet. Please add your contacts first.</p>
        <p
            v-else-if="!contactTypes.length"
            class="text-muted mb-0"
        >No contact types are available.</p>

        <role-matrix-table
            v-else
            :contacts="contacts"
            :columns="columns"
            :value="normalizedValue"
            :disabled="localDisabled"
            @input="onInput"
        ></role-matrix-table>
    </div>
</template>

<script>
// a matrix of contacts (rows) x contact types / TenantRoles (columns) - check a cell to give that person that contact type
// used by the backend TenantRoleMatrixInput (renderer key 'tenant_role_matrix') - value is { role_slug: [tu_id, ...] }
// min/max per column are enforced by the 'tenantRoleLimits' validation rule (built by the backend) - the table only shows them
import RoleMatrixTable from './RoleMatrixTable';

export default {
    name: 'FormulateTenantRoleMatrix',
    components: {
        RoleMatrixTable,
    },
    props: {
        context: {  // standard Formulate input context
            type: Object,
            required: true,
        },
        contacts: {  // rows: [{ id, full_name, email, job_title }]
            type: Array,
            default: () => [],
        },
        contactTypes: {  // columns: [{ slug, name, description, min, max }] - max is null for no limit
            type: Array,
            default: () => [],
        },
    },
    computed: {
        localDisabled() {
            return this.context.attributes?.disabled ?? this.context.disabled ?? false;
        },
        columns() {
            return this.contactTypes.map(ct => ({ ...ct, key: ct.slug }));
        },
        normalizedValue() {
            // Formulate may give us '' / null before there is a value - always work with an array for every column
            const model = (this.context.model && typeof this.context.model === 'object') ? this.context.model : {};
            return Object.fromEntries(this.contactTypes.map(ct => [ct.slug, Array.isArray(model[ct.slug]) ? model[ct.slug] : []]));
        },
    },
    methods: {
        onInput(newValue) {
            this.context.model = newValue;
            this.context.blurHandler();  // there is no real blur on a checkbox grid - this shows validation errors right away
        },
    },
};
</script>
